import styled from "styled-components";

export const Wrapper = styled.div`
  flex: 1 1;
`;

export const Message = styled.div`
  display: flex;
  justify-content: center;
  padding: 30px;
`;
